/**
 * 全局加载条，模拟页面加载
 */

import { useDidMount } from '../../../shared/hooks';
import './style.scss';

let node = document.createElement('div');
let innerNode = document.createElement('div');

node.className = 'page-progress';
innerNode.className = 'inner';
innerNode.style.transform = 'translate3d(0,0,0)';
innerNode.style.width = '0%';
node.appendChild(innerNode);
document.body.appendChild(node);

const setProgress = (precent: number) => {
  innerNode.style.width = precent + '%';
};

let cancelLastMove = () => {};

let delayTimeout: NodeJS.Timeout | null = null;
let closeTimeout: NodeJS.Timeout | null = null;

let startIndex = 0;
let started = false;

const startNow = () => {
  started = true;
  node.style.display = 'block';
  innerNode.style.opacity = '1';
  innerNode.style.width = '0%';
  innerNode.style.transition = 'none';

  setTimeout(() => {
    innerNode.style.transition = 'width 4s ease';
    setProgress(90);
  }, 20);

  return;
};

const start = () => {
  clearTimeout(closeTimeout!);
  clearTimeout(delayTimeout!);

  startIndex++;

  if (started) return;

  delayTimeout = setTimeout(() => {
    startNow();
  }, 50);
};

const finish = () => {
  clearTimeout(delayTimeout!);

  startIndex--;

  if (startIndex !== 0) return;

  delayTimeout = setTimeout(() => {
    cancelLastMove();
    innerNode.style.transition = 'width .4s ease, opacity .5s linear .3s';
    innerNode.style.width = '100%';
    innerNode.style.opacity = '0';
    closeTimeout = setTimeout(() => {
      node.style.display = 'none';
    }, 800);
    started = false;
  }, 100);
};

export default function PageProgress() {
  useDidMount(() => {
    start();

    return finish;
  });

  return null;
}

PageProgress.start = start;
PageProgress.finish = finish;
